import type { LucideIcon } from "lucide-react";
import { BarChart2, LayoutDashboard, Megaphone, MessageCircle, ReceiptIndianRupee, Settings, Trophy, Users } from "lucide-react";

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  section: "main" | "management";
};

export const NAV_ITEMS: NavItem[] = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, section: "main" },
  { to: "/players", label: "Players", icon: Users, section: "main" },
  { to: "/billing", label: "Billing", icon: ReceiptIndianRupee, section: "main" },
  { to: "/invoices", label: "Reports", icon: BarChart2, section: "main" },
  { to: "/tournament", label: "Tournament", icon: Trophy, section: "main" },
  { to: "/reminders", label: "Reminders", icon: Megaphone, section: "management" },
  { to: "/settings/whatsapp", label: "WhatsApp", icon: MessageCircle, section: "management" },
  { to: "/settings", label: "Settings", icon: Settings, section: "management" },
];
